export interface ISnTimezones {
  [name: string]: number;
}
